import { EnvConfigInterface } from './types';
import { Environment } from './enums';

export const EnvConfig: EnvConfigInterface = {
  ENV: (process.env.ENV as Environment) || Environment.prod,
  CDN_URL: process.env.CDN_URL || '',
  PUBLISHER_PROJECT_ID: process.env.PUBLISHER_PROJECT_ID || '130226',
  GTM_TAG: process.env.GTM_TAG || 'GTM-PXDK5D4',
  PS_SANDBOX: process.env.PS_SANDBOX === 'true',

  // API
  API_URL: process.env.API_URL || 'https://babka.com/api',
  GATEWAY_API_URL: process.env.GATEWAY_API_URL || 'https://wallet.xsolla.com/api',
  MARKETING_CONSENT_API_URL: process.env.MARKETING_CONSENT_API_URL || 'https://mcs.xsolla.com/api/v1',
  LOGIN_URL: process.env.LOGIN_URL || 'https://login.xsolla.com/api',
  WALLET_API_URL: process.env.WALLET_API_URL || 'https://wallet.babka.com/api',
  MERCHANT_URL: process.env.MERCHANT_URL || 'https://api.xsolla.com/merchant',
  XSOLLA_MONEY_GATEWAY_API_URL: process.env.XSOLLA_MONEY_GATEWAY_API_URL || 'https://money-api.xsolla.com/api',
  XSOLLA_PAY_GATEWAY_API_URL: process.env.XSOLLA_PAY_GATEWAY_API_URL || 'https://pay.xsolla.com/api',
  VIRTUAL_CURRENCY_GATEWAY_API_URL: process.env.VIRTUAL_CURRENCY_GATEWAY_API_URL || 'https://currency-wallet.xsolla.com',
  XP_GATEWAY_API_URL: process.env.XP_GATEWAY_API_URL || 'https://xp-gateway-1058717008157.us-central1.run.app',
  // Login
  LOGIN_WIDGET_URL: process.env.LOGIN_WIDGET_URL || 'https://login-widget.xsolla.com',
  LOGIN_WIDGET_PROJECT_ID: process.env.LOGIN_WIDGET_PROJECT_ID || '89c824d7-9b5d-11eb-bc85-42010aa80004',
  LOGIN_WIDGET_CLIENT_ID: parseInt(process.env.LOGIN_WIDGET_CLIENT_ID || '4660', 10),

  // Xsolla ID (social provider in the Login project)
  XSOLLA_ID_LOGIN_PROVIDER: process.env.XSOLLA_ID_LOGIN_PROVIDER || 'xsolla-id',

  // Xsolla Consent
  XSOLLA_CONSENT_URL: process.env.XSOLLA_CONSENT_URL || 'https://metaframe-id.xsolla.com/assets/apps/consent.js',

  // Chat
  CHAT_URL: process.env.CHAT_URL || '',
  CHAT_SCRIPT_URL: process.env.CHAT_SCRIPT_URL || 'https://cdn.chat.xsolla.com/widget/livechat-iframe.js',

  // AB Experiments
  AB_API_URL: process.env.AB_API_URL || 'https://ab.xsolla.com/v2',
  AB_PRODUCT_NAME: process.env.AB_PRODUCT_NAME || 'babka-account',
  AB_LOYALTY_PROJECT_ID: process.env.AB_LOYALTY_PROJECT_ID || '',

  // Analytics
  ANALYTICS_API_URL: process.env.ANALYTICS_API_URL || 'https://datagather.xsolla.com',

  // Feature Flags
  CONFIG_CAT_SDK_KEY: process.env.CONFIG_CAT_SDK_KEY || '',

  // Backpack (@xsolla/backpack): the merchant configuration it loads from backpack-api. The fallback follows ENV like
  // getBackpackEnvironment does: every build but production calls Backpack's Stage API, which doesn't know the prod ID.
  BACKPACK_CONFIGURATION_ID:
    process.env.BACKPACK_CONFIGURATION_ID ||
    (((process.env.ENV as Environment) || Environment.prod) === Environment.prod
      ? '70a1ac6f-0cd0-4c01-8e6f-fbf81f656182'
      : 'bfe68d08-9241-41be-8ac9-6f5421fc3673'),

  // Remotes
  XSOLLA_PAY_CARDS_REMOTE_URL: process.env.XSOLLA_PAY_CARDS_REMOTE_URL || 'https://mf.babka.com/pay-cards-account',

  VIRTUAL_CURRENCY_REMOTE_URL: process.env.VIRTUAL_CURRENCY_REMOTE_URL || 'https://virtual-currency.vercel.app',

  XP_REMOTE_URL: process.env.XP_REMOTE_URL || 'https://x-xp-c2933.web.app/xp',

  // Backpack
  BACKPACK_REMOTE_URL: process.env.BACKPACK_REMOTE_URL || 'https://mf.babka.com/backpack-account',

  // Parental Control
  PARENTAL_CONTROL_REMOTE_URL: process.env.PARENTAL_CONTROL_REMOTE_URL || 'https://mf.babka.com/parent-control-account',

  // Xsolla Money
  XSOLLA_MONEY_REMOTE_URL: process.env.XSOLLA_MONEY_REMOTE_URL || 'https://xsolla-money.vercel.app',

  // Dev options
  get SHOW_MODULE_TEMPLATE() {
    return this.ENV === Environment.dev && process.env.SHOW_MODULE_TEMPLATE === 'true';
  },
  MODULE_TEMPLATE_REMOTE_URL: process.env.MODULE_TEMPLATE_REMOTE_URL || 'http://localhost:8080'
};
